import { devtools } from "zustand/middleware";
import { create } from "zustand/react";

type WizardState = {
  isOpen: boolean;
  contractId?: number | null;
  open: (contractId?: number | null) => void;
  close: () => void;
  taskId?: number | null;
  setTaskId: (taskId: number | null) => void;
  isArchived: boolean;
  setArchived: (isArchived: boolean) => void;
};

export const useCreateContractWizardStore = create<WizardState>()(
  devtools((set, _) => ({
    isOpen: false,
    contractId: null,
    open: (id) => set({ isOpen: true, contractId: id ?? null }),
    taskId: null,
    setTaskId: (taskId) => set({ taskId }),
    close: () => set({ isOpen: false, contractId: null, taskId: null }),
    isArchived: false,
    setArchived: (isArchived) => set({ isArchived }),
  }))
);
